<template>
    <title>横浜市問合せフォーム</title>
        <v-container class="px-4">
          <v-col>
          <h2>概要</h2>
          <p>横浜市の窓口案内・各種手続きについてお尋ねになりたいことがございましたら、「お問合せ内容」欄に記入してください。</p>
          <p>お問合せは、担当部署に対応を引き継ぐため、回答までに２週間程度お時間をいただきます。</p>
          <br>
          <p>お急ぎの際は、担当課に直接お問い合わせ下さい。</p>
          <p>組織一覧：<a class="word-wrap"
              href="https://www.city.yokohama.lg.jp/city-info/yokohamashi/org/soshiki-gyomu/">
              https://www.city.yokohama.lg.jp/city-info/yokohamashi/org/soshiki-gyomu/</a>
          </p>
          <hr />
          <h2>お問合せ先</h2>
          <p>横浜市コールセンター</p>
          <p>電話番号：045-664-2525</p>
          <p>受付時間：午前８時～午後９時（土日祝日を含む毎日）</p>
          <hr />

          <span v-if="isAnnounce">
            <h2>{{AnnounceTitle}}</h2>
            <div v-html="AnnounceBody"></div>
            <hr />
          </span>
        </v-col>
        <v-col class="text-center">
          <v-btn title="次へ進む" variant="elevated" class="custom-btn" to="/inquiry">
            次へ進む
          </v-btn>
        </v-col>
      </v-container>
</template>

<script>
import { ref, onMounted } from 'vue';
import axios from 'axios';

export default {
  name: 'HomePage',
  setup(){

    let AnnounceTitle = ref('');
    let AnnounceBody = ref('');
    let isAnnounce = ref(false);

    const getAnnouce = async () =>{
      AnnounceTitle.value = "";
      AnnounceBody.value = "";
      try{
        var url = process.env.VUE_APP_ANNOUNCE_API_URL;
        var res = await axios.get(url);
        //console.log(url,":", res);
        if(res.status == 200){
          AnnounceTitle.value = res.data.announceTitle;
          AnnounceBody.value = res.data.announceBody;
        }
        isAnnounce.value = AnnounceTitle.value != "" && AnnounceBody.value != ""
      } catch (error) {
        //console.log("annouce data error:", error);
      }
    }

    onMounted(async () => {
      await getAnnouce();
    });

    return{
      isAnnounce,
      AnnounceTitle,
      AnnounceBody
    }
  },
}
</script>
<style scoped>

header
{
  padding: 0 !important;
}

h2 {
  color: rgb(38, 90, 185);
  font-size: 1.2em;
  font-weight: bold;
}

hr {
  margin-top: 20pt;
  margin-bottom: 20pt;
}

.word-wrap {
  word-wrap: break-word;
  /* 旧ブラウザ向け */
  overflow-wrap: break-word;
  /* モダンブラウザ向け */
}

.custom-btn {
  background-color: #0071BD;
  color: white;
  border: 1px solid rgb(1, 11, 163);
  border-radius: 6px;
  cursor: pointer;
  vertical-align:middle;
  transition: background-color 0.3s ease;
}

.custom-btn:hover {
  border-color: #003366; /* ダークブルーの枠 */
  background-color: #9fa6c8; /* ホバー時の背景色 */
}
</style>